import { Component, ElementRef, ViewEncapsulation, OnInit, AfterViewInit, Inject, OnDestroy } from '@angular/core';
import { DialogPanelComponentContent } from '../../models/dialogs/DialogPanelComponentContent';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable ,  Subscription } from 'rxjs';
import { UsersState } from '../../state-management/users/users.reducer';
import { AppState } from '../../interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { LoginWraperService } from '../../services/login.wraper.service';
import { SettingsService } from '../../services/settings/settings.service';
import { UsersAction } from '../../state-management/users/users.actions';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Roles as RolesUser } from '../../models/roles/roles.enum';

const exitWebApp: any = null;

@AutoUnsubscribe()
@Component({
    selector: 'tr-side-menu',
    styleUrls: ['./tr-side-menu.component.scss'],
    templateUrl: './tr-side-menu.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class TrSideMenuComponent extends DialogPanelComponentContent implements AfterViewInit, OnDestroy {

    public logged: boolean;
    public hasToroRadar: boolean = true;
    public authentication$: Observable<UsersState>;
    public user$: Observable<UsersState>;
    public registerAppUrl: string = '';
    public userRole: string;
    public RolesUser = RolesUser;
    private authenticationSubscription: Subscription;

    public get insideWebAppEnvironment(): boolean {
        return typeof exitWebApp === 'function';
    }
    constructor(
        element: ElementRef,
        private router: Router,
        private dialogReference: MatDialogRef<TrSideMenuComponent>,
        private store: Store<AppState>,
        private loginWraper: LoginWraperService,
        @Inject(MAT_DIALOG_DATA) private external: boolean,
        private settingsService: SettingsService,
    ) {

        super(element, true);
        this.user$ = this.store.select((s) => s.authentication);
        this.registerAppUrl = this.settingsService.getConfigurationKeyValue('rau');

        this.authenticationSubscription = this.user$
            .filter((state) => state.currentUser && state.currentUser.token)
            .subscribe((state) => {
                this.logged = state.currentUser.token;
                this.userRole = state.currentUser.role;
        });
    }

    public ngAfterViewInit() {
        this.router.events.subscribe((e) => this.closeMenu());
    }

    public closeMenu() {
        super.close(this.dialogReference, null);
    }

    public login() {
        this.closeMenu();
        this.loginWraper.navigateToLogin();
    }

    /** Realiza a navegação da url requisitada */
    public redirect(url: string) {

        if (
            this.external
            || url.equals('/bolsa/investir')
            || url.equals('/fundos/investir')
            || url.equals('/produtos-renda-fixa/investir')
            || new RegExp('/home').test(window.location.href)
        ) {

            this.redirectExternal(url);

        } else {

            this.router.navigateByUrl(url);

        }

    }

    public openExternalHrefLink(param: string ) {
        window.open(param);
    }

    public logout() {
        this.store.dispatch({ type: UsersAction.logout, payload: { externalRouter: this.external } });
        // Função do ambiente do WebApp
        if (this.insideWebAppEnvironment) {
            exitWebApp();
        }
    }

    // não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    // tslint:disable-next-line:no-empty
    public ngOnDestroy() { }

    private redirectExternal(url: string) {

        if (window.location.href !== url) {
            window.location.href = url;
        }
    }
}
